import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/k8s_training_web/k8s_training_web/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You must have the following setup on your PC:`}</p>
    <ul>
      <li parentName="ul">{`Podman`}</li>
      <li parentName="ul">{`Minikube`}</li>
      <li parentName="ul">{`Git`}</li>
    </ul>
    <p>{`This requires a minimum of:`}</p>
    <ul>
      <li parentName="ul">{`2 physical CPU cores`}</li>
      <li parentName="ul">{`6 GB of free memory`}</li>
    </ul>
    <p>{`For the MeshNetwork (Istio) Lab you need a minimum of:`}</p>
    <ul>
      <li parentName="ul">{`4 physical CPU cores`}</li>
      <li parentName="ul">{`9 GB of free memory`}</li>
    </ul>
    <InlineNotification kind="info" mdxType="InlineNotification">
If Minikube is not an option you can use OpenShift Local or any other Kubernetes solution (but this is untested and you're on your own).
    </InlineNotification>
    <h2>{`🚀 TASK: Install prerequisites on Mac`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Install Homebrew`}</p>
        <p parentName="li">{`Follow the instructions `}<a href="https://docs.brew.sh/Installation" target="_blank">{`🌏 here`}</a>{` to install Homebrew on your Mac.`}</p>
      </li>
    </ol>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Install CLI Tools`}</p>
        <a href="https://kubernetes.io/docs/tasks/tools/" target="_blank">🌏 Detailed Documentation for the Task</a>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`brew install kubernetes-cli
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install Podman and Podman Desktop`}</p>
        <a href="https://podman-desktop.io/downloads/macos" target="_blank">🌏 Detailed Documentation for the Task</a>
        <p parentName="li">{`Download the App and install manually or`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`brew install --cask podman-desktop
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Start Podman from the command line`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`export CONTAINERS_MACHINE_PROVIDER=applehv
podman machine init --cpus 4 --memory 6666
podman machine start
`}</code></pre>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`<InlineNotification kind="warning">

If you get errors regarding 'krunkit' binary, make sure that you select the Apple Hypervisor as runtime.

</InlineNotification>
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Start Podman from the Podman Desktop`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Open Podman Desktop`}</li>
          <li parentName="ul">{`Go to `}<strong parentName="li">{`Settings`}</strong>{` `}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`Create New`}</strong>{` under Podman`}</li>
          <li parentName="ul">{`Make sure you select `}<inlineCode parentName="li">{`Apple Hypervisor`}</inlineCode>{` under `}<strong parentName="li">{`Provider type`}</strong></li>
          <li parentName="ul">{`Hit `}<strong parentName="li">{`Create`}</strong></li>
        </ul>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`![K8s CNI](./../images/podman1.png)
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">
        <p parentName="li">{`Install Minikube`}</p>
        <a href="https://kubernetes.io/fr/docs/tasks/tools/install-minikube/" target="_blank">🌏 Detailed Documentation for the Task</a>
        <ol parentName="li">
          <li parentName="ol">
            <p parentName="li">{`Install Minikube`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`brew install minikube
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Start Minikube `}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`minikube start --driver=podman --container-runtime=containerd
`}</code></pre>
          </li>
        </ol>
        <p parentName="li">{`or use the Podman Desktop.`}</p>
      </li>
    </ol>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">
        <p parentName="li">{`Install some addons we will need later`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`minikube addons enable registry    
minikube addons enable ingress    
minikube addons enable dashboard    
minikube addons list|grep enabled
`}</code></pre>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-output"
          }}>{`| dashboard                   | minikube | enabled ✅   | Kubernetes                     |
| default-storageclass        | minikube | enabled ✅   | Kubernetes                     |
| ingress                     | minikube | enabled ✅   | Kubernetes                     |
| registry                    | minikube | enabled ✅   | Google                         |
| storage-provisioner         | minikube | enabled ✅   | Google                         |
`}</code></pre>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      